export default __webpack_public_path__ + "static/typography-image-f-4e74583484f48c0ea61999603ebf0960668e177934bd03704febbded8bd53b66.png";